import { Component, CUSTOM_ELEMENTS_SCHEMA, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-button',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './delete-button.component.html',
  styleUrls: ['./delete-button.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DeleteButtonComponent {
  public deletePointClickEmitter = output<void>();

  public handleDeletePointClick() {
    this.deletePointClickEmitter.emit();
  }

}
